import { STATIC_MEDIA_URL } from '../../config_module';

export let getPublicImg = (name, baseUrl) => {
  if (!baseUrl) {
    baseUrl = STATIC_MEDIA_URL;
  }
  return `${baseUrl}/${name}`;
};
